/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus {
    Created = 0,
    Cancelled = 1,
    Completed = 2,
    NUMBER_unknown_default_open_api = 11184809
}


export function instanceOfFxIdDomainModelsDBStoreDBOrderOptimisticUserStatus(value: any): boolean {
    for (const key in FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus, key)) {
            if (FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus[key as keyof typeof FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FxIdDomainModelsDBStoreDBOrderOptimisticUserStatusFromJSON(json: any): FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus {
    return FxIdDomainModelsDBStoreDBOrderOptimisticUserStatusFromJSONTyped(json, false);
}

export function FxIdDomainModelsDBStoreDBOrderOptimisticUserStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus {
    return json as FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus;
}

export function FxIdDomainModelsDBStoreDBOrderOptimisticUserStatusToJSON(value?: FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus | null): any {
    return value as any;
}

export function FxIdDomainModelsDBStoreDBOrderOptimisticUserStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus {
    return value as FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus;
}

